// Consecutive periods of one class and subject read as one block ("Tiết 3-4"). Only .ts-suffixed runtime imports, so node --test loads it directly.

import type { Id, QltTimetableDayCell } from '../api/types';
import { periodStartMinutes } from '../config/periods.ts';

export interface PeriodGroup {
  cells: QltTimetableDayCell[];
  first: number;
  last: number;
}

export function entityId(value: { id?: Id; _id?: string } | Id | null | undefined): string {
  if (value === null || value === undefined) return '';
  if (typeof value !== 'object') return String(value);
  return String(value.id === undefined ? value._id || '' : value.id);
}

export function groupPeriods(cells: QltTimetableDayCell[]): PeriodGroup[] {
  const sorted = cells.slice().sort((a, b) => a.index - b.index);
  const groups: PeriodGroup[] = [];
  for (let i = 0; i < sorted.length; i += 1) {
    const cell = sorted[i];
    const previous = groups[groups.length - 1];
    const first = previous && previous.cells[0];
    const same = Boolean(previous && previous.last + 1 === cell.index && first &&
      entityId(first.class) === entityId(cell.class) &&
      entityId(first.subject) === entityId(cell.subject) &&
      entityId(first.teacher) === entityId(cell.teacher));
    if (same) {
      previous.cells.push(cell);
      previous.last = cell.index;
    } else {
      groups.push({ cells: [cell], first: cell.index, last: cell.index });
    }
  }
  return groups;
}

export function vietnamMinutesNow(nowMs: number = Date.now()): number {
  const shifted = new Date(nowMs + 7 * 60 * 60 * 1000);
  return shifted.getUTCHours() * 60 + shifted.getUTCMinutes();
}

/** The latest period of the block that has started by `now`; the first one before the block begins. */
export function periodToOpen(group: PeriodGroup, now: number): QltTimetableDayCell {
  let chosen = group.cells[0];
  for (let i = 1; i < group.cells.length; i += 1) {
    const start = periodStartMinutes(group.cells[i].index);
    if (start !== null && now >= start) chosen = group.cells[i];
  }
  return chosen;
}

/** "Tiết 3", or "Tiết 3-4" for a block. */
export function periodGroupLabel(first: number, last: number = first): string {
  return first === last ? `Tiết ${first}` : `Tiết ${first}-${last}`;
}
